export default {
      id: "ic_search-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_search",
      toString: function () {
        return this.url;
      }
    }